<template>
    <q-list>
        <q-collapsible class="filter" icon="fas fa-filter" :label="$t('filter')" :opened="!$q.platform.is.mobile ? true : false">
            <q-list no-border>
                <q-item>
                    <q-item-main>
                        <q-search v-model="search" :placeholder="$t('search')" icon="fas fa-search" :debounce="500" />
                    </q-item-main>
                </q-item>

                <q-item>
                    <q-item-main>
                        <p class="caption">{{ $t('knowledge_areas') }}</p>
                        <q-item tag="label" v-for="(area, index) in all_areas" :key="index" link>
                            <q-item-side>
                                <q-checkbox v-model="areas" :val="area.value" />
                            </q-item-side>
                            <q-item-main>
                                <q-item-tile label class="text-weight-light">{{ area.label }}</q-item-tile>
                            </q-item-main>
                        </q-item>
                    </q-item-main>
                </q-item>

                <q-item>
                    <q-item-main>
                        <p class="text-center">
                            <a href="#" @click.prevent="clearFilters()" class="text-faded">
                                <q-icon name="far fa-trash-alt" /> {{ $t('clear_filters') }}
                            </a>
                        </p>
                    </q-item-main>
                </q-item>
            </q-list>
        </q-collapsible>
    </q-list>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            selected_client_params: []
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            search_store: 'live_classes/search',
            tags_store: 'live_classes/tags',
            areas_store: 'live_classes/areas',
            all_tags: 'registration_lists/tags',
            all_areas: 'registration_lists/country_areas',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        search: {
            get() {
                return this.search_store
            },
            set(val) {
                this.$store.dispatch('live_classes/SET_SEARCH', [val])
            }
        },

        tags: {
            get() {
                return this.tags_store
            },
            set(val) {
                this.$store.dispatch('live_classes/SET_TAGS', [val])
            }
        },

        areas: {
            get() {
                return this.areas_store
            },
            set(val) {
                this.$store.dispatch('live_classes/SET_AREAS', [val])
            },
        }
    },

    methods: {
        clearFilters() {
            this.$store.dispatch('live_classes/SET_CLEAR_FILTERS', ['', [], 'all'])
        },

        removeTag(id) {
            const index = this.tags.indexOf(id)
            this.tags.splice(index, 1)
        },

        getName(id) {
            let obj = this.all_tags.find((obj) => { return obj.value === id })
            if (obj) return obj.label
            else return ''
        }
    },

    created() {
        this.clearFilters()
        this.selected_client_params = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
    }
}
</script>

<style lang="stylus" scoped>
p
    margin 0 0 10px

p
    &.tags
        margin 0 0 5px

a
    text-decoration none
</style>
